import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html'
})
export class ConfirmModalComponent {
  ok: Function;
  cancel: Function;
  labels: string[];
  text: string;

  constructor(public bsModalRef: BsModalRef) {}
}
